var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthorisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3065_2731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.102 27.0181H80.2635V13.9926H98.5069C98.691 13.9926 98.8408 13.8429 98.8408 13.6588C98.8408 13.4747 98.691 13.325 98.5069 13.325H63.5643V0.667653H91.2938C91.4779 0.667653 91.6276 0.517897 91.6276 0.333824C91.6276 0.149752 91.4779 0 91.2938 0H13.743C13.559 0 13.4092 0.149752 13.4092 0.333824C13.4092 0.517897 13.559 0.667653 13.743 0.667653H31.4437V13.325H0.333819C0.149747 13.325 0 13.4747 0 13.6588C0 13.8429 0.149747 13.9926 0.333819 13.9926H49.1146V27.0181H7.05091C6.86684 27.0181 6.71709 27.1679 6.71709 27.3519C6.71709 27.536 6.86684 27.6858 7.05091 27.6858H18.4775V40.1777H13.5761C13.3921 40.1777 13.2423 40.3275 13.2423 40.5116C13.2423 40.6956 13.3921 40.8454 13.5761 40.8454H56.8426C57.0266 40.8454 57.1764 40.6956 57.1764 40.5116C57.1764 40.3275 57.0266 40.1777 56.8426 40.1777H32.1113V27.6858H62.8982V40.5116C62.8982 40.6956 63.048 40.8454 63.2321 40.8454C63.4161 40.8454 63.5659 40.6956 63.5659 40.5116V27.6858H109.104C109.288 27.6858 109.437 27.536 109.437 27.3519C109.437 27.1679 109.288 27.0181 109.104 27.0181H109.102ZM32.1097 0.667653H62.8967V13.325H32.1097V0.667653ZM49.7807 13.9911H79.5958V27.0166H49.7807V13.9911ZM31.4421 40.1762H19.1435V27.6842H31.4421V40.1762Z",
    fill: "#E9EAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.998 147.129H161.297V134.904H184.022C184.206 134.904 184.356 134.754 184.356 134.57C184.356 134.386 184.206 134.236 184.022 134.236H179.94V121.744H184.022C184.206 121.744 184.356 121.595 184.356 121.411C184.356 121.226 184.206 121.077 184.022 121.077H161.297V108.051H185.704C185.888 108.051 186.037 107.901 186.037 107.717C186.037 107.533 185.888 107.384 185.704 107.384H148.485V94.7262H166.186C166.37 94.7262 166.519 94.5765 166.519 94.3924C166.519 94.2084 166.37 94.0586 166.186 94.0586H77.8822C77.6981 94.0586 77.5484 94.2084 77.5484 94.3924C77.5484 94.5765 77.6981 94.7262 77.8822 94.7262H84.9082V107.384H53.9106C53.7266 107.384 53.5768 107.533 53.5768 107.717C53.5768 107.901 53.7266 108.051 53.9106 108.051H69.1809V121.077H43.3155C43.1315 121.077 42.9817 121.226 42.9817 121.411C42.9817 121.595 43.1315 121.744 43.3155 121.744H53.5768V134.236H23.2173C23.0332 134.236 22.8835 134.386 22.8835 134.57C22.8835 134.754 23.0332 134.904 23.2173 134.904H35.076V147.129H5.45742C5.27334 147.129 5.1236 147.279 5.1236 147.463C5.1236 147.647 5.27334 147.797 5.45742 147.797H22.8835V159.665C22.8835 159.849 23.0332 159.999 23.2173 159.999C23.4014 159.999 23.5511 159.849 23.5511 159.665V147.797H53.5784V159.665C53.5784 159.849 53.7281 159.999 53.9122 159.999C54.0963 159.999 54.246 159.849 54.246 159.665V147.797H179.272V159.665C179.272 159.849 179.422 159.999 179.606 159.999C179.79 159.999 179.94 159.849 179.94 159.665V147.797H187.998C188.182 147.797 188.332 147.647 188.332 147.463C188.332 147.279 188.182 147.129 187.998 147.129ZM160.631 147.129H69.8516V134.904H160.631V147.129ZM116.366 121.744V134.236H85.5789V121.744H116.366ZM130.149 108.051V121.077H100.334V108.051H130.149ZM117.034 134.236V121.744H147.82V134.236H117.034ZM179.275 134.236H148.488V121.744H179.275V134.236ZM160.632 121.077H130.817V108.051H160.632V121.077ZM147.82 107.384H117.034V94.7262H147.82V107.384ZM85.5789 94.7262H116.366V107.384H85.5789V94.7262ZM69.8516 108.05H99.6667V121.075H69.8516V108.05ZM54.2476 121.743H84.9113V134.235H54.2476V121.743ZM35.7467 134.902H69.184V147.128H35.7467V134.902Z",
    fill: "#E9EAFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3065_2731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.196 110.363C141.474 115.915 128.007 129.095 109.388 130.706C92.4494 132.171 50.5815 143.914 38.487 132.893C31.691 121.602 47.0196 111.858 47.0196 111.858C47.0196 111.858 70.6851 126.179 106.451 119.974C116.975 118.149 133.593 119.291 147.196 110.363Z",
    fill: "#D9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5569 25.4045C23.8971 22.6419 88.9296 28.3388 88.9296 28.3388C93.5822 31.5376 112.733 42.4485 108.372 67.1132C103.041 97.2649 26.8412 67.1695 26.8581 55.2438C26.882 38.532 17.7964 28.699 12.5569 25.4045Z",
    fill: "#7B81EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9731 22.4475C28.3133 19.6849 93.3457 25.3817 93.3457 25.3817C97.9984 28.5806 117.149 39.4915 112.788 64.1561C107.457 94.3079 26.6653 64.1843 26.9552 52.2629C27.2465 40.3415 22.5447 25.9855 16.9731 22.4475Z",
    fill: "#D9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7772 19.9766L108.367 24.6292C113.02 27.828 120.372 38.7811 116.01 63.4458C110.68 93.5976 123.49 119.38 138.829 114.582C130.611 118.924 112.304 130.704 53.4141 126.976C51.3791 132.21 38.0039 143.259 31.025 120.87C24.0461 98.481 26.3724 59.8107 26.6637 47.8893C26.955 35.9679 26.3724 23.1754 16.7772 19.9766Z",
    fill: "url(#paint0_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9688 130.757C42.0751 136.717 49.0287 137.88 59.6667 130.705C71.4432 132.21 106.625 134.681 138.319 119.969C131.277 129.973 115.764 137.677 105.752 138.613C98.1767 139.322 65.0215 141.653 49.0287 137.88C45.7201 137.099 40.7663 136.329 35.9688 130.757Z",
    fill: "#7B81EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.8023 123.858C56.1893 123.858 50.8077 118.478 50.8077 111.864C50.8077 105.249 56.1879 99.8691 62.8023 99.8691C69.4167 99.8691 74.7969 105.249 74.7969 111.864C74.7969 118.478 69.4167 123.858 62.8023 123.858ZM62.8023 100.305C56.4285 100.305 51.2439 105.49 51.2439 111.864C51.2439 118.237 56.4285 123.422 62.8023 123.422C69.1761 123.422 74.3607 118.237 74.3607 111.864C74.3607 105.49 69.1761 100.305 62.8023 100.305Z",
    fill: "url(#paint1_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4961 118.553C73.1916 114.857 73.1916 108.866 69.4961 105.17C65.8006 101.475 59.8091 101.475 56.1136 105.17C52.4181 108.866 52.4181 114.857 56.1136 118.553C59.8091 122.248 65.8006 122.248 69.4961 118.553Z",
    fill: "url(#paint2_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8058 119.219C58.7499 119.219 55.4511 115.92 55.4511 111.864C55.4511 107.809 58.7499 104.51 62.8058 104.51C66.8617 104.51 70.1605 107.809 70.1605 111.864C70.1605 115.92 66.8617 119.219 62.8058 119.219ZM62.8058 105.091C59.0707 105.091 56.0323 108.129 56.0323 111.864C56.0323 115.599 59.0707 118.638 62.8058 118.638C66.5408 118.638 69.5792 115.599 69.5792 111.864C69.5792 108.129 66.5408 105.091 62.8058 105.091Z",
    fill: "url(#paint3_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1135 115.171C67.9415 113.343 67.9415 110.379 66.1135 108.552C64.2856 106.724 61.3219 106.724 59.4939 108.552C57.666 110.379 57.666 113.343 59.4939 115.171C61.3219 116.999 64.2856 116.999 66.1135 115.171Z",
    fill: "url(#paint4_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.566 119.719C105.179 119.719 104.836 119.623 104.533 119.432C101.277 117.371 105.075 105.068 105.238 104.546C106.945 99.0803 106.356 95.434 105.393 94.5896C105.164 94.3883 104.99 94.4334 104.881 94.4854C104.24 94.7838 103.182 96.7456 103.282 102.213C103.438 110.779 102.044 115.373 100.68 116.016C100.408 116.144 100.132 116.114 99.9227 115.934C99.4611 115.539 99.409 114.496 99.7862 113.213C100.452 110.945 100.087 109.953 99.934 109.904C99.9255 109.904 99.8791 109.919 99.8087 109.988C99.4288 110.366 98.7954 111.922 98.8292 115.359C98.8405 116.53 98.5858 117.294 98.1129 117.513C97.8568 117.632 97.564 117.575 97.3121 117.356C96.3566 116.528 95.5192 112.938 97.3417 106.832C97.7878 105.339 97.678 104.414 97.3698 104.161C97.2587 104.068 97.1053 104.072 96.9139 104.172C95.9414 104.681 94.5538 107.365 94.9732 112.401C95.2631 115.874 94.8817 118.216 93.9261 118.825C93.6334 119.011 93.297 119.022 93.0015 118.853C92.4963 118.565 92.1881 117.827 92.2176 116.976C92.2232 116.815 92.3612 116.69 92.5174 116.696C92.6778 116.701 92.8031 116.835 92.7974 116.995C92.7735 117.686 93.0268 118.199 93.2886 118.348C93.397 118.41 93.5011 118.406 93.6123 118.335C94.1696 117.981 94.7072 116.226 94.3933 112.45C93.9472 107.098 95.4939 104.259 96.6436 103.658C97.0433 103.449 97.4416 103.468 97.7385 103.713C98.3198 104.193 98.3775 105.391 97.8976 106.999C96.1046 113.002 97.0053 116.323 97.6907 116.917C97.7428 116.962 97.8145 117.011 97.8666 116.986C98.0242 116.912 98.255 116.421 98.2452 115.364C98.2142 112.146 98.7701 109.798 99.6624 109.383C99.8932 109.276 100.135 109.309 100.327 109.472C100.89 109.957 100.895 111.489 100.342 113.374C99.9734 114.628 100.12 115.338 100.298 115.491C100.317 115.508 100.344 115.529 100.429 115.488C101.075 115.184 102.878 112.094 102.698 102.223C102.615 97.718 103.357 94.5502 104.633 93.9577C105.02 93.7775 105.425 93.8465 105.774 94.1519C107.038 95.258 107.473 99.3379 105.791 104.719C104.297 109.504 102.718 117.595 104.841 118.94C105.829 119.565 107.688 118.662 110.219 116.328C110.337 116.22 110.521 116.227 110.63 116.345C110.738 116.464 110.731 116.648 110.613 116.756C108.464 118.739 106.796 119.72 105.563 119.72L105.566 119.719Z",
    fill: "url(#paint5_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.075 51.1414H106.07L77.7981 50.4617C77.6771 50.4588 77.5828 50.3589 77.5856 50.2379C77.5884 50.1169 77.6898 50.0254 77.8094 50.0254L106.081 50.7051C106.202 50.7079 106.296 50.8079 106.294 50.9289C106.291 51.0471 106.194 51.1414 106.075 51.1414Z",
    fill: "url(#paint6_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.123 32.4004C104.123 32.4004 104.119 32.4004 104.118 32.4004L89.2452 31.9951C89.1242 31.9923 89.0299 31.891 89.0327 31.7713C89.0355 31.6503 89.1326 31.5532 89.2565 31.5588L104.129 31.9641C104.25 31.9669 104.344 32.0683 104.342 32.1879C104.339 32.3061 104.242 32.4004 104.123 32.4004Z",
    fill: "url(#paint7_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4883 31.9278H86.4827L77.7981 31.7195C77.677 31.7167 77.5828 31.6168 77.5856 31.4957C77.5884 31.3747 77.6897 31.2818 77.8093 31.2832L86.4939 31.4915C86.615 31.4943 86.7092 31.5942 86.7064 31.7153C86.7036 31.8335 86.6065 31.9278 86.4883 31.9278Z",
    fill: "url(#paint8_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8382 50.3883H74.8326L57.3367 49.9675C57.2157 49.9647 57.1214 49.8648 57.1242 49.7438C57.127 49.6227 57.2269 49.5299 57.348 49.5313L74.8438 49.9521C74.9649 49.9549 75.0592 50.0548 75.0563 50.1758C75.0535 50.294 74.9564 50.3883 74.8382 50.3883Z",
    fill: "url(#paint9_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0657 54.7443C99.0657 54.7443 99.0615 54.7443 99.0601 54.7443L71.2429 54.0027C71.1219 53.9999 71.0276 53.8999 71.0304 53.7789C71.0332 53.6607 71.1303 53.5664 71.2485 53.5664C71.2499 53.5664 71.2527 53.5664 71.2542 53.5664L99.0713 54.3081C99.1924 54.3109 99.2867 54.4108 99.2838 54.5318C99.281 54.65 99.1839 54.7443 99.0657 54.7443Z",
    fill: "url(#paint10_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6316 54.0027H68.626L42.1219 53.3933C42.0008 53.3905 41.9065 53.2906 41.9094 53.1695C41.9122 53.0513 42.0093 52.957 42.1275 52.957H42.1331L68.6373 53.5664C68.7583 53.5692 68.8526 53.6691 68.8498 53.7888C68.847 53.907 68.7499 54.0013 68.6316 54.0013V54.0027Z",
    fill: "url(#paint11_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6575 58.2008H83.6518L54.7933 57.5281C54.6722 57.5253 54.5779 57.4253 54.5807 57.3043C54.5836 57.1833 54.6891 57.0904 54.8045 57.0918L83.6631 57.7645C83.7841 57.7673 83.8784 57.8672 83.8756 57.9883C83.8728 58.1065 83.7757 58.2008 83.6575 58.2008Z",
    fill: "url(#paint12_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2878 57.4034H51.2821L42.1219 57.1824C42.0008 57.1796 41.9065 57.0797 41.9094 56.9587C41.9122 56.8376 42.0079 56.7433 42.1331 56.7462L51.2934 56.9671C51.4144 56.9699 51.5087 57.0698 51.5059 57.1909C51.5031 57.3091 51.406 57.4034 51.2878 57.4034Z",
    fill: "url(#paint13_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.466 62.3836H101.463L92.5079 62.2527C92.3869 62.2513 92.2912 62.1514 92.2926 62.0317C92.294 61.9121 92.3911 61.8164 92.5108 61.8164H92.5136L101.468 61.9473C101.589 61.9487 101.685 62.0486 101.684 62.1682C101.682 62.2879 101.585 62.3836 101.466 62.3836Z",
    fill: "url(#paint14_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0355 62.2522C89.0355 62.2522 89.0313 62.2522 89.0299 62.2522L71.2455 61.7455C71.1245 61.7427 71.0302 61.6414 71.0344 61.5218C71.0373 61.4008 71.1386 61.3065 71.2582 61.3107L89.0426 61.8173C89.1636 61.8201 89.2579 61.9215 89.2537 62.0411C89.2509 62.1593 89.1537 62.2536 89.0355 62.2536V62.2522Z",
    fill: "url(#paint15_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.227 61.7444C69.227 61.7444 69.2228 61.7444 69.22 61.7444L42.1205 60.976C41.9995 60.9732 41.9052 60.8719 41.9094 60.7522C41.9137 60.6326 42.0136 60.5369 42.1332 60.5412L69.2326 61.3095C69.3537 61.3124 69.448 61.4137 69.4437 61.5333C69.4409 61.6515 69.3438 61.7458 69.2256 61.7458L69.227 61.7444Z",
    fill: "url(#paint16_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7849 65.3988C49.7849 65.3988 49.7764 65.3988 49.7722 65.3988L46.6268 65.3186C46.3454 65.3115 46.1244 65.0779 46.1315 64.7965C46.1385 64.515 46.3679 64.2912 46.6536 64.3011L49.7989 64.3813C50.0804 64.3883 50.3013 64.622 50.2943 64.9034C50.2873 65.1793 50.0607 65.3988 49.7863 65.3988H49.7849Z",
    fill: "url(#paint17_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5036 66.1575C91.5036 66.1575 91.5008 66.1575 91.4994 66.1575L82.6149 65.9675C82.4939 65.9647 82.3996 65.8648 82.401 65.7452C82.4038 65.6269 82.5009 65.5312 82.6192 65.5312C82.6206 65.5312 82.622 65.5312 82.6234 65.5312L91.5078 65.7212C91.6289 65.724 91.7231 65.824 91.7217 65.9436C91.7189 66.0618 91.6218 66.1575 91.5036 66.1575Z",
    fill: "url(#paint18_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7157 65.8606C79.7157 65.8606 79.7128 65.8606 79.71 65.8606L53.3382 65.2513C53.2171 65.2484 53.1229 65.1485 53.1257 65.0289C53.1285 64.9107 53.2256 64.8164 53.3438 64.8164C53.3452 64.8164 53.3466 64.8164 53.3494 64.8164L79.7213 65.4258C79.8423 65.4286 79.9366 65.5285 79.9338 65.6481C79.931 65.7663 79.8339 65.8606 79.7157 65.8606Z",
    fill: "url(#paint19_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6426 69.1058C46.3625 69.1058 46.1345 68.8792 46.1331 68.5992C46.1331 68.3177 46.3583 68.0897 46.6398 68.0883L49.8541 68.0742H49.8569C50.1369 68.0742 50.3649 68.3008 50.3663 68.5809C50.3663 68.8623 50.1412 69.0903 49.8597 69.0917L46.6454 69.1058H46.6426Z",
    fill: "url(#paint20_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.088 70.2615C106.088 70.2615 106.086 70.2615 106.083 70.2615L53.3349 69.0428C53.2138 69.04 53.1196 68.94 53.1224 68.8204C53.1252 68.6994 53.2265 68.5995 53.3447 68.6079L106.093 69.8267C106.214 69.8295 106.308 69.9294 106.305 70.0504C106.302 70.1686 106.205 70.2629 106.087 70.2629L106.088 70.2615Z",
    fill: "url(#paint21_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.976 77.6628H87.0626C86.9416 77.6628 86.8445 77.5657 86.8445 77.4447C86.8445 77.3237 86.9416 77.2266 87.0626 77.2266H103.976C104.097 77.2266 104.194 77.3237 104.194 77.4447C104.194 77.5657 104.097 77.6628 103.976 77.6628Z",
    fill: "url(#paint22_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6554 77.5902L42.8373 77.3777C42.7163 77.3777 42.6192 77.2792 42.6206 77.1581C42.6206 77.0385 42.7191 76.9414 42.8387 76.9414L83.6568 77.1539C83.7778 77.1539 83.8749 77.2524 83.8735 77.3734C83.8735 77.4931 83.775 77.5902 83.6554 77.5902Z",
    fill: "url(#paint23_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.519 81.3871L42.914 81.1042C42.793 81.1042 42.6959 81.0057 42.6973 80.8847C42.6973 80.7651 42.7958 80.668 42.9154 80.668L100.52 80.9508C100.641 80.9508 100.738 81.0494 100.737 81.1704C100.737 81.29 100.638 81.3871 100.519 81.3871Z",
    fill: "url(#paint24_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.126 85.1122L62.1944 84.97C62.0734 84.97 61.9763 84.8715 61.9763 84.7519C61.9763 84.6323 62.0748 84.5352 62.1944 84.5352L104.127 84.6773C104.248 84.6773 104.345 84.7758 104.344 84.8954C104.344 85.0151 104.245 85.1122 104.126 85.1122Z",
    fill: "url(#paint25_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1245 84.8269H42.9887C42.8677 84.8269 42.7706 84.7298 42.7706 84.6088C42.7706 84.4877 42.8677 84.3906 42.9887 84.3906H58.1245C58.2455 84.3906 58.3426 84.4877 58.3426 84.6088C58.3426 84.7298 58.2455 84.8269 58.1245 84.8269Z",
    fill: "url(#paint26_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7033 88.6956H61.7019L42.9873 88.5535C42.8663 88.5535 42.7706 88.4535 42.7706 88.3339C42.7706 88.2143 42.8691 88.1172 42.9887 88.1172H42.9901L61.7047 88.2593C61.8257 88.2593 61.9214 88.3592 61.9214 88.4789C61.9214 88.5985 61.8229 88.6956 61.7033 88.6956Z",
    fill: "url(#paint27_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7484 39.7848L95.4845 41.4115C96.4943 41.4491 97.2837 42.2995 97.2461 43.3092L97.2416 43.4302C97.2041 44.4399 96.3537 45.2293 95.3439 45.1918L51.6078 43.5651C50.598 43.5275 49.8086 42.6772 49.8462 41.6674L49.8507 41.5465C49.8882 40.5367 50.7386 39.7473 51.7484 39.7848Z",
    fill: "url(#paint28_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.527 49.6452H42.1606C42.0396 49.6452 41.9425 49.5481 41.9425 49.4271C41.9425 49.3061 42.0396 49.209 42.1606 49.209H45.527C45.648 49.209 45.7451 49.3061 45.7451 49.4271C45.7451 49.5481 45.648 49.6452 45.527 49.6452Z",
    fill: "url(#paint29_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4351 49.9422H55.4294L49.0247 49.8001C48.9037 49.7973 48.8094 49.6974 48.8122 49.5777C48.815 49.4567 48.9121 49.3652 49.0345 49.3652L55.4393 49.5074C55.5603 49.5102 55.6546 49.6101 55.6518 49.7297C55.649 49.8479 55.5519 49.9422 55.4336 49.9422H55.4351Z",
    fill: "url(#paint30_linear_3065_2731)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.077 58.7237H106.071L86.8486 58.2761C86.7276 58.2733 86.6333 58.1734 86.6361 58.0524C86.6389 57.9313 86.736 57.8385 86.8599 57.8399L106.083 58.2874C106.204 58.2902 106.298 58.3901 106.295 58.5112C106.292 58.6294 106.195 58.7237 106.077 58.7237Z",
    fill: "url(#paint31_linear_3065_2731)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3065_2731",
    x: 9.1452,
    y: 19.9766,
    width: 138.051,
    height: 125.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.41168,
    dy: 5.11753
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3065_2731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3065_2731",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3065_2731",
    x1: 55.493,
    y1: 16.043,
    x2: 107.241,
    y2: 145.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3065_2731",
    x1: 62.8023,
    y1: 99.8691,
    x2: 62.8072,
    y2: 137.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3065_2731",
    x1: 56.1136,
    y1: 105.17,
    x2: 76.8354,
    y2: 125.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3065_2731",
    x1: 62.8058,
    y1: 104.51,
    x2: 62.8088,
    y2: 127.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3065_2731",
    x1: 59.4939,
    y1: 108.552,
    x2: 69.7439,
    y2: 118.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3065_2731",
    x1: 101.461,
    y1: 93.8594,
    x2: 101.468,
    y2: 133.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3065_2731",
    x1: 91.9396,
    y1: 50.0254,
    x2: 91.9396,
    y2: 51.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3065_2731",
    x1: 96.6872,
    y1: 31.5586,
    x2: 96.6872,
    y2: 32.8619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3065_2731",
    x1: 82.146,
    y1: 31.2832,
    x2: 82.146,
    y2: 32.2811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3065_2731",
    x1: 66.0903,
    y1: 49.5312,
    x2: 66.0903,
    y2: 50.8582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3065_2731",
    x1: 85.1571,
    y1: 53.5664,
    x2: 85.1571,
    y2: 55.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3065_2731",
    x1: 55.3796,
    y1: 52.957,
    x2: 55.3796,
    y2: 54.5759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3065_2731",
    x1: 69.2282,
    y1: 57.0918,
    x2: 69.2282,
    y2: 58.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3065_2731",
    x1: 46.7076,
    y1: 56.7461,
    x2: 46.7076,
    y2: 57.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3065_2731",
    x1: 96.9882,
    y1: 61.8164,
    x2: 96.9882,
    y2: 62.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3065_2731",
    x1: 80.1441,
    y1: 61.3105,
    x2: 80.1441,
    y2: 62.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3065_2731",
    x1: 55.6766,
    y1: 60.541,
    x2: 55.6766,
    y2: 62.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3065_2731",
    x1: 48.2129,
    y1: 64.3008,
    x2: 48.2129,
    y2: 66.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3065_2731",
    x1: 87.0614,
    y1: 65.5312,
    x2: 87.0614,
    y2: 66.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3065_2731",
    x1: 66.5297,
    y1: 64.8164,
    x2: 66.5297,
    y2: 66.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3065_2731",
    x1: 48.2497,
    y1: 68.0742,
    x2: 48.2498,
    y2: 69.6713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3065_2731",
    x1: 79.7138,
    y1: 68.6074,
    x2: 79.7138,
    y2: 71.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3065_2731",
    x1: 95.5192,
    y1: 77.2266,
    x2: 95.5192,
    y2: 77.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3065_2731",
    x1: 63.2471,
    y1: 76.9414,
    x2: 63.2471,
    y2: 77.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3065_2731",
    x1: 71.717,
    y1: 80.668,
    x2: 71.717,
    y2: 81.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3065_2731",
    x1: 83.16,
    y1: 84.5352,
    x2: 83.16,
    y2: 85.4285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3065_2731",
    x1: 50.5566,
    y1: 84.3906,
    x2: 50.5566,
    y2: 85.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3065_2731",
    x1: 52.346,
    y1: 88.1172,
    x2: 52.346,
    y2: 89.0127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3065_2731",
    x1: 73.6164,
    y1: 40.5982,
    x2: 73.3988,
    y2: 46.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3065_2731",
    x1: 43.8438,
    y1: 49.209,
    x2: 43.8438,
    y2: 49.8844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3065_2731",
    x1: 52.232,
    y1: 49.3652,
    x2: 52.232,
    y2: 50.2586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3065_2731",
    x1: 96.4656,
    y1: 57.8398,
    x2: 96.4656,
    y2: 59.2082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C3FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3065_2731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorisation);
export default __webpack_public_path__ + "static/media/authorisation.27b4249299a6ad15009a395b1f21cbcd.svg";
export { ForwardRef as ReactComponent };